import { forwardRef, InputHTMLAttributes } from 'react';
import styles from './EmailInput.module.css';

type EmailInputProps = InputHTMLAttributes<HTMLInputElement> & {
  styleType?: 'solid';
  hasError: boolean;
};

export const EmailInput = forwardRef<HTMLInputElement, EmailInputProps>(
  ({ styleType, hasError, className, ...rest }, ref) => (
    <input
      {...rest}
      ref={ref}
      type="email"
      // Unwired a11y placeholders, and they clobber consumer-passed aria props.
      // Backlog: docs/a11y-maintenance-backlog.md#emailinput
      aria-label=""
      aria-invalid={undefined}
      aria-describedby=""
      data-style-type={styleType}
      data-has-error={hasError}
      className={[styles.root, className].filter(Boolean).join(' ')}
    />
  ),
);

EmailInput.displayName = 'EmailInput';
